import React, { createContext, useCallback, useState } from 'react';

export interface PathSegment {
  text: string;
  url: string;
}

interface LocationContextType {
  path: PathSegment[];
  setPath: (path: PathSegment[]) => void;
}

export const LocationContext = createContext<LocationContextType | undefined>(undefined);

export const LocationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [path, setPath] = useState<PathSegment[]>([]);

  const updatePath = useCallback((newPath: PathSegment[]) => {
    
    setPath(newPath);
  }, []);

  return (
    <LocationContext.Provider value={{ path, setPath: updatePath }}>
      {children}
    </LocationContext.Provider>
  );
};
